import React, { useState } from 'react';
import styles from './CandleCalendar.module.css'; // Import the CSS module
import { GoChevronLeft, GoChevronRight } from 'react-icons/go';

const CandleCalendar = props => {
  const { onChange, onClose, currentDate, monthlyTimeSlots, divRef, minDate, maxDate } = props;

  const [currentMonthIndex, setCurrentMonthIndex] = useState(0);
  const currentDaySelected = new Date(currentDate).getDate();
  const today = new Date(); // Get today's date for comparison
  today.setHours(0, 0, 0, 0);

  const date = new Date();

  // Generate the current month and the next three months
  const getMonths = () => {
    const months = [];
    for (let i = 0; i < 4; i++) {
      const month = new Date(date.getFullYear(), date.getMonth() + i, 1);
      months.push(month);
    }
    return months;
  };

  const months = getMonths(); // Get the months to display
  const currentMonth = months[currentMonthIndex]; // Get the current month

  // Get enabled dates based on time slots
  const getEnabledDates = value => {
    // const enabledDates = new Set();
    // const monthKey = currentMonth.toISOString().slice(0, 7); // Format as 'YYYY-MM'
    // // Check if the monthlyTimeSlots object has data for the current month
    // if (monthlyTimeSlots[monthKey]) {
    //   monthlyTimeSlots[monthKey].timeSlots.forEach(slot => {
    //     const start = new Date(slot.attributes.start);
    //     const end = new Date(slot.attributes.end);
    //     // Add each date in the range to the enabled set
    //     for (let dt = new Date(start); dt <= end; dt.setDate(dt.getDate() + 1)) {
    //       enabledDates.add(dt.toISOString().slice(0, 10)); // Format as 'YYYY-MM-DD'
    //     }
    //   });
    // }
    // return enabledDates;
  };

  const enabledDates = getEnabledDates(); // Get the enabled dates for the current month

  // Render the calendar for the current month
  const renderCalendar = month => {
    const firstDayOfMonth = new Date(month.getFullYear(), month.getMonth(), 1);
    const lastDayOfMonth = new Date(month.getFullYear(), month.getMonth() + 1, 0);

    const days = [];

    // Monday-start adjustment
    const startDay = (firstDayOfMonth.getDay() + 6) % 7;

    // Add empty placeholders before the first day
    for (let i = 0; i < startDay; i++) {
      days.push(null);
    }

    // Add actual days of the month
    for (let i = 1; i <= lastDayOfMonth.getDate(); i++) {
      days.push(new Date(month.getFullYear(), month.getMonth(), i));
    }

    const checkDate = day => {
      if (!day) return false;
      const targetDate = new Date(day);
      targetDate.setHours(0, 0, 0, 0);

      const today = new Date();
      today.setHours(0, 0, 0, 0);

      if (targetDate < today) return false;

      if (minDate) {
        const min = new Date(minDate);
        min.setHours(0, 0, 0, 0);
        if (targetDate < min) return false;
      }

      if (maxDate) {
        const max = new Date(maxDate);
        max.setHours(0, 0, 0, 0);
        if (targetDate > max) return false;
      }

      if (!monthlyTimeSlots || Object.keys(monthlyTimeSlots).length === 0) return false;

      for (const month in monthlyTimeSlots) {
        const timeSlots = monthlyTimeSlots[month].timeSlots || [];
        for (const slot of timeSlots) {
          const startDate = new Date(slot.attributes.start);
          const endDate = new Date(slot.attributes.end);
          startDate.setHours(0, 0, 0, 0);
          endDate.setHours(0, 0, 0, 0);
          if (targetDate >= startDate && targetDate <= endDate) return true;
        }
      }

      return false;
    };

    return (
      <div className={styles.month}>
        <div className={styles.days}>
          {days.map((day, idx) => {
            if (!day) {
              return <div key={idx} className={styles.empty}></div>;
            }

            const isEnabled = checkDate(day);
            const isToday =
              day.getDate() === today.getDate() &&
              day.getMonth() === today.getMonth() &&
              day.getFullYear() === today.getFullYear();

            return (
              <div
                key={day}
                className={`${styles.day} ${
                  day.getDate() === currentDaySelected &&
                  day.getMonth() === new Date(currentDate).getMonth() &&
                  day.getFullYear() === new Date(currentDate).getFullYear()
                    ? styles.selected_class
                    : ''
                } ${isEnabled ? '' : styles.disabled} ${isToday ? styles.today : ''}`}
                onClick={() => {
                  if (isEnabled) {
                    onChange(day);
                    onClose();
                  }
                }}
              >
                {day.getDate()}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  // Handle next month navigation
  const handleNext = () => {
    if (currentMonthIndex < 3) {
      setCurrentMonthIndex(currentMonthIndex + 1);
    }
  };

  // Handle previous month navigation
  const handlePrevious = () => {
    if (currentMonthIndex > 0) {
      setCurrentMonthIndex(currentMonthIndex - 1);
    }
  };

  return (
    <div ref={divRef} className={styles.calendar}>
      <div className={styles.navigation}>
        <span
          onClick={handlePrevious}
          disabled={currentMonthIndex === 0}
          className={currentMonthIndex === 0 ? styles.disabled : ''}
        >
          <GoChevronLeft />
        </span>
        <h2 className={styles.h2}>
          {currentMonth.toLocaleString('default', { month: 'long' })} {currentMonth.getFullYear()}
        </h2>
        <span
          onClick={handleNext}
          disabled={currentMonthIndex === 3}
          className={currentMonthIndex === 3 ? styles.disabled : ''}
        >
          <GoChevronRight />
        </span>
      </div>
      {renderCalendar(currentMonth)} {/* Display only the current month */}
    </div>
  );
};

export default CandleCalendar;
